<template>
  <div>
    <div class="topnav-cont">
      <div class="left-menu">
        <div class="menu-item">
          <div class="logo-cont"></div>
        </div>
        <div class="menu-item">
          <a
            href="https://access.gaminglabs.com/Certificate/Index?i=354"
            target="_blank"
            class="logo-cert"
          ></a>
        </div>
        <div class="menu-item">
          <div class="desktop-varcont menu-toggle-item" @click="checkBalance()">
            <span v-if="user.balance != ''">
              {{ user.curr }} {{ formatPrice }}
              <div class="loading-icon" v-if="user.checking"></div>
            </span>
            <span v-else>{{ user.curr }} 0.00</span>
            <div class="toggle-tooltip">{{ $t("general.wallet") }}</div>
          </div>
        </div>

        <!-- <div class="menu-item">
        <div class="menu-dropdown">
          <template v-if="options.displayMode == 'normal'">{{ localization['menunormal'] }}</template>

          <template v-if="options.displayMode == 'simple'">{{ localization['menusimple'] }}</template>

          <span></span>
          <div class="dropdown-list">
            <div class="dropdown-item" @click="options.displayMode = 'normal'">{{ localization['menunormal'] }}</div>
            <div class="dropdown-item" @click="options.displayMode = 'simple'">{{ localization['menusimple'] }}</div>
            <div class="dropdown-item menutrend" @click="options.displayMode = 'trend'">{{ localization['menutrend'] }}</div>
          </div>

        </div>
        </div>-->

        <div class="menu-item">
          <div class="menu-dropdown">
            {{ languages[lang_id].name }}
            <span></span>
            <div class="dropdown-list" style="min-width: 135px">
              <div
                v-for="(lang, key) in languages"
                class="dropdown-item"
                @click="setLocale(key)"
              >
                {{ lang.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="menu-item currenttime">{{ currentTime }}</div>
      </div>

      <div class="right-menu">
        <div class="menu-item menu-username">
          <div ref="username-menu" class="menu-dropdown">
            <div
              ref="marquee"
              class="marquee"
              :class="{ 'marquee-active': isMarquee }"
            >
              <b>{{ user.username }}</b>
            </div>
            <span></span>
            <div class="dropdown-list">
              <a class="dropdown-item" :href="logoutURL">{{
                $t("general.menulogout")
              }}</a>
            </div>
          </div>
        </div>

        <div class="menu-item">
          <div
            :class="['menu-toggle-item', soundOn ? 'soundon' : 'soundoff']"
            href="javascript:void(0)"
            @click="toggleSound"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.928"
                height="21.927"
                viewBox="0 0 21.928 21.927"
              >
                <g transform="translate(-6534.5 -14643.5)">
                  <g id="speaker" transform="translate(6535 14641.989)">
                    <path
                      d="M11.352,3.172a1.21,1.21,0,0,0-1.235.018.371.371,0,0,0-.052.037L4.65,7.808H.4a.4.4,0,0,0-.4.4V15.8a.4.4,0,0,0,.4.4l4.241,0,5.413,4.972a.39.39,0,0,0,.064.048,1.211,1.211,0,0,0,1.235.018,1.248,1.248,0,0,0,.638-1.1V4.273A1.249,1.249,0,0,0,11.352,3.172Zm-.161,16.964a.459.459,0,0,1-.231.406.419.419,0,0,1-.4.01L5.2,15.624V13.8a.4.4,0,1,0-.8,0v1.6l-3.6,0V8.607H4.4v1.6a.4.4,0,0,0,.8,0V8.393l5.358-4.532a.418.418,0,0,1,.406.007.458.458,0,0,1,.231.405Z"
                      transform="translate(0 0)"
                      fill="#fff"
                      stroke="#fff"
                      stroke-width="0.8"
                    />
                    <path
                      d="M38,7.034a.4.4,0,0,0-.257.757,6.987,6.987,0,0,1,.009,13.232.4.4,0,0,0,.129.778.394.394,0,0,0,.129-.022A7.787,7.787,0,0,0,38,7.034Z"
                      transform="translate(-22.497 -2.403)"
                      fill="#fff"
                      stroke="#fff"
                      stroke-width="0.8"
                    />
                    <path
                      d="M34.948,15.989a3.627,3.627,0,0,0-2.607-3.467.267.267,0,1,0-.148.514,3.073,3.073,0,0,1,0,5.905.267.267,0,0,0,.074.524.272.272,0,0,0,.074-.01A3.626,3.626,0,0,0,34.948,15.989Z"
                      transform="translate(-18.21 -3.985)"
                      fill="#fff"
                      stroke="#fff"
                      stroke-width="0.8"
                    />
                  </g>
                  <path
                    class="stroke"
                    d="M9297.84,13967l-19.928,19.928"
                    transform="translate(-2742.412 677.499)"
                    fill="none"
                    stroke="#00fdf3"
                    stroke-linecap="round"
                    stroke-width="2"
                  />
                </g>
              </svg>
            </span>
            <div class="toggle-tooltip">
              {{ $t("general.menusfx") }}:
              {{ soundOn ? $t("general.menuon") : $t("general.menuoff") }}
            </div>
          </div>
        </div>

        <div class="menu-item">
          <div
            :class="['menu-toggle-item', goodroadOn ? 'roadon' : 'roadoff']"
            href="javascript:void(0)"
            @click="toggleGoodroad"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22.756"
                height="22.756"
                viewBox="0 0 22.756 27"
              >
                <g transform="translate(-1529.086 -78)">
                  <g
                    transform="translate(1530 78)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1537 78)"
                    fill="none"
                    stroke="#3e7ffd"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1530 85)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1544 78)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1544 85)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1537 85)"
                    fill="none"
                    stroke="#3e7ffd"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1544 92)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1537 92)"
                    fill="none"
                    stroke="#3e7ffd"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1544 99)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1537 99)"
                    fill="none"
                    stroke="#3e7ffd"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1530 99)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <g
                    transform="translate(1530 92)"
                    fill="none"
                    stroke="#fa594f"
                    stroke-width="1.5"
                  >
                    <circle cx="3" cy="3" r="3" stroke="none" />
                    <circle cx="3" cy="3" r="2.25" fill="none" />
                  </g>
                  <path
                    class="stroke"
                    d="M9297.84,13967l-6.228,6.228-1.11,1.11-2.057,2.058-10.533,10.532"
                    transform="translate(-7747.412 -13885.501)"
                    fill="none"
                    stroke="#ffbd54"
                    stroke-linecap="round"
                    stroke-width="2"
                  />
                </g>
              </svg>
            </span>
            <div class="toggle-tooltip">
              {{ $t("general.goodroad") }}
              {{ goodroadOn ? $t("general.menuon") : $t("general.menuoff") }}
            </div>
          </div>
        </div>

        <!-- rules button "@click="openWindow(rulesUrl)"-->
        <div class="menu-item">
          <div
            class="menu-toggle-item"
            href="javascript:void(0)"
            @click="$root.openWindow(rulesUrl)"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <g transform="translate(-1255 -25)">
                  <g id="question-mark" transform="translate(1256.447 30.71)">
                    <path
                      d="M8.323,0c1.632,0,3.238.751,3.238,2.549,0,1.658-1.9,2.295-2.307,2.894-.306.446-.2,1.072-1.045,1.072a.811.811,0,0,1-.816-.854c0-1.518,2.23-1.861,2.23-3.111,0-.688-.458-1.1-1.223-1.1-1.632,0-.995,1.682-2.23,1.682a.763.763,0,0,1-.829-.777C5.34,1.108,6.767,0,8.323,0ZM8.259,7.342A1.046,1.046,0,1,1,7.214,8.387,1.05,1.05,0,0,1,8.259,7.342Z"
                      transform="translate(0)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Ellipse_907"
                    data-name="Ellipse 907"
                    transform="translate(1255 25)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1.5"
                  >
                    <circle cx="10" cy="10" r="10" stroke="none" />
                    <circle cx="10" cy="10" r="9.25" fill="none" />
                  </g>
                </g>
              </svg>
            </span>

            <div class="toggle-tooltip">{{ $t("general.menurules") }}</div>
          </div>
        </div>
        <!-- game history button "@click="openWindow(gamehistoryUrl)"-->
        <div class="menu-item">
          <div
            class="menu-toggle-item"
            href="javascript:void(0)"
            @click="$root.openWindow(gamehistoryUrl)"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="14.004"
                viewBox="0 0 16 14.004"
              >
                <g transform="translate(-8578.002 -13913)">
                  <g>
                    <path
                      d="M7186.263,15366.8s-4.946-.008-8.421,0"
                      transform="translate(1406.739 -1452.799)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <path
                      d="M7179.844,15366.8s-1.174,0-2,0"
                      transform="translate(1401.158 -1452.798)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                  </g>
                  <g transform="translate(0 12)">
                    <path
                      d="M7186.263,15366.8s-4.946-.008-8.421,0"
                      transform="translate(1406.739 -1452.799)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <path
                      d="M7179.844,15366.8s-1.174,0-2,0"
                      transform="translate(1401.158 -1452.798)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                  </g>
                  <g transform="translate(8579.002 13920)">
                    <path
                      d="M7177.842,15366.8s4.946-.008,8.421,0"
                      transform="translate(-7177.842 -15366.799)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                    <path
                      d="M7177.844,15366.8s1.174,0,2,0"
                      transform="translate(-7165.844 -15366.798)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-width="2"
                    />
                  </g>
                </g>
              </svg>
            </span>

            <div class="toggle-tooltip">{{ $t("general.menuresult") }}</div>
          </div>
        </div>
        <!-- statement button "@click="openWindow(statementUrl)" -->
        <div class="menu-item">
          <div
            class="menu-toggle-item"
            href="javascript:void(0)"
            @click="$root.openWindow(statementUrl)"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                viewBox="0 0 18 20"
              >
                <g id="writing" transform="translate(-26.57)">
                  <g transform="translate(26.57)">
                    <g>
                      <path
                        d="M116.328,200.8a.8.8,0,0,0-.8-.8h-8.264a.8.8,0,1,0,0,1.6h8.264A.8.8,0,0,0,116.328,200.8Z"
                        transform="translate(-103.407 -192.205)"
                        fill="#fff"
                      />
                      <path
                        d="M107.261,280a.8.8,0,0,0,0,1.6h5.019a.8.8,0,0,0,0-1.6Z"
                        transform="translate(-103.365 -269.087)"
                        fill="#fff"
                      />
                      <path
                        d="M32.315,18.438H29.7a1.565,1.565,0,0,1-1.564-1.562V3.125A1.565,1.565,0,0,1,29.7,1.563h9.617A1.565,1.565,0,0,1,40.88,3.125v4.8a.782.782,0,0,0,1.564,0v-4.8A3.131,3.131,0,0,0,39.316,0H29.7A3.131,3.131,0,0,0,26.57,3.125v13.75A3.131,3.131,0,0,0,29.7,20h2.616a.781.781,0,1,0,0-1.562Z"
                        transform="translate(-26.57)"
                        fill="#fff"
                      />
                      <path
                        d="M252.46,272.728a2.41,2.41,0,0,0-3.4,0l-4.4,4.4a.8.8,0,0,0-.2.335l-.959,3.158a.8.8,0,0,0,.982,1.006l3.238-.9a.8.8,0,0,0,.353-.205l4.4-4.387A2.41,2.41,0,0,0,252.46,272.728Zm-5.38,6.507-1.629.451.477-1.57,2.972-2.966,1.135,1.135ZM251.326,275l-.155.155-1.135-1.135.155-.155A.8.8,0,0,1,251.326,275Z"
                        transform="translate(-235.164 -261.651)"
                        fill="#fff"
                      />
                      <path
                        d="M115.526,120h-8.264a.8.8,0,1,0,0,1.6h8.264a.8.8,0,0,0,0-1.6Z"
                        transform="translate(-103.407 -115.323)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </span>

            <div class="toggle-tooltip">{{ $t("general.menustatement") }}</div>
          </div>
        </div>

        <!-- notification button "@click="openWindow(notificationUrl)"-->
        <div class="menu-item">
          <div
            class="menu-toggle-item"
            href="javascript:void(0)"
            @click="$root.openWindow(notificationUrl)"
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="20"
                viewBox="0 0 16 20"
              >
                <path
                  id="Icon"
                  d="M1409,39a1,1,0,0,1-1-1V33a5.687,5.687,0,0,0-5-5.921V26a1,1,0,1,0-2,0v1.079A5.687,5.687,0,0,0,1396,33v5a1,1,0,0,1-1,1,1,1,0,0,0,0,2h4v1a3,3,0,1,0,6,0V41h4a1,1,0,0,0,0-2Zm-6,3a1,1,0,1,1-2,0V41h2Zm3-3h-8V33a3.843,3.843,0,0,1,4-4h0a3.843,3.843,0,0,1,4,4Z"
                  transform="translate(-1394 -25)"
                  fill="#fff"
                />
              </svg>
            </span>

            <div class="toggle-tooltip">
              {{ $t("general.menunotification") }}
            </div>
          </div>
        </div>
        <div class="menu-item">
          <!-- <div
            class="menu-toggle-item"
            href="javascript:void(0)"
            @click="$root.openWindow(notificationUrl)"
          >-->
          <!-- <div class="menu-toggle-item" @click="favmodal = true">
            <span>
              <svg
                fill="#fff"
                height="22"
                viewBox="0 0 16 16"
                width="22"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m12.853 16.0905c-.0688477 0-.138184-.014183-.203125-.0430384l-4.61816-2.05606-4.61816 2.05606c-.170898.0758066-.370117.0493956-.515625-.0670033-.145996-.116888-.214355-.30567-.177734-.489072l1.01855-5.10249-3.56055-3.5668c-.130371-.130582-.178223-.322299-.125-.499343.0532227-.176555.199707-.309583.380371-.345774l5.10352-1.02265 2.0376-4.59239c.161133-.361913.75293-.361913.914063 0l2.0376 4.59239 5.10352 1.02265c.180664.0361915.327148.169219.380371.345774.0532227.177044.0053711.368761-.125.499343l-3.56055 3.5668 1.01855 5.10249c.0366211.183402-.0317383.372184-.177734.489072-.0903321.072383-.201172.110042-.3125.110042zm-4.82129-3.14816c.0693359 0 .138672.014183.203125.0430384l3.93848 1.75381-.881836-4.41681c-.0327148-.164328.0185547-.334036.136719-.452392l3.08936-3.09436-4.44092-.890111c-.15918-.0317899-.292969-.138897-.358887-.287575l-1.68604-3.7996-1.68604 3.7996c-.065918.148678-.199707.255785-.358887.287575l-4.44092.890111 3.08936 3.09436c.118164.118356.169434.288064.136719.452392l-.881836 4.41681 3.93848-1.75381c.064453-.0288553.133789-.0430384.203125-.0430384z"
                  transform="translate(-.032 -.09)"
                />
              </svg>
            </span>

            <div class="toggle-tooltip">{{ $t("general.menufavourite") }}</div>
            <Modal
              class="favmodal"
              v-model="favmodal"
              :title="$t('general.favouritegame')"
              :ok-text="$t('general.confirm')"
              :cancel-text="$t('general.cancel')"
              @on-ok="ok"
              @on-cancel="cancel"
            >
              <div class="fav-title">{{$t('general.menufavourite')}}</div>
              <template v-for="(game,index) in fav_array">
                <Card class="game-fav-list" :key="game.gID">
                  <div style="text-align:center">{{game.title}}</div>
                  <div>
                    <Button v-if="index!=0" type="primary" @click="favUp(game)">
                      <Icon type="ios-arrow-up"></Icon>
                    </Button>

                    <Button
                      v-if="index != fav_array.length -1 "
                      type="primary"
                      @click="favDown(game)"
                    >
                      <Icon type="ios-arrow-down"></Icon>
                    </Button>

                    <Button type="primary" @click="delFav(game)">
                      <Icon type="ios-star-outline"></Icon>
                    </Button>
                  </div>
                </Card>
              </template>
              <Divider />
              <div class="fav-title">{{$t('general.availablegame')}}</div>
              <template v-for="game in games">
                <Card class="game-list" :key="game.gID" v-if="!gIDArray.includes(game.gID)">
                  <div style="text-align:center">{{game.title}}</div>
                  <Button type="primary" @click="addToFav(game)">
                    <Icon type="ios-star"></Icon>
                  </Button>
                </Card>
              </template>
            </Modal>
          </div>-->
        </div>
      </div>
    </div>
    <div class="header-mobile">
      <div class="left-nav">
        <span @click="toggleMobDrawer" href="javascript:void(0)">
          <svg
            fill="currentColor"
            preserveAspectRatio="xMidYMid meet"
            height="14"
            width="14"
            viewBox="0 0 512 512"
            style="vertical-align: middle"
          >
            <g>
              <path
                d="M49.6 123.2h411.9c25.2 0 45.8-16 45.8-35.5s-20.6-35.5-45.8-35.5H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5zm411.9 97.3H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5h411.9c25.2 0 45.8-16 45.8-35.5s-20.5-35.5-45.8-35.5zm0 168.3H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5h411.9c25.2 0 45.8-16 45.8-35.5s-20.5-35.5-45.8-35.5z"
              />
            </g>
          </svg>
        </span>
      </div>
      <div class="center-nav">
        <div class="mobile-varcont" @click="checkBalance()">
          <span v-if="user.balance">
            {{ user.curr }} {{ formatPrice }}
            <div class="loading-icon" v-if="user.checking"></div>
          </span>
          <span v-else>{{ user.curr }} 0.00</span>
        </div>

        <div class="mobile-varcont username">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.146"
            height="14.146"
            viewBox="0 0 14.146 14.146"
          >
            <path
              id="Union_1"
              data-name="Union 1"
              d="M0,14.146V12.378c0-1.946,3.183-3.536,7.073-3.536s7.073,1.591,7.073,3.536v1.768ZM3.536,3.536A3.536,3.536,0,1,1,7.073,7.073,3.536,3.536,0,0,1,3.536,3.536Z"
              transform="translate(0 0)"
              fill="#fff"
            />
          </svg>
          {{ user.username }}
        </div>
      </div>

      <div :class="['mobile-left-drawer', openDrawer ? 'open' : '']">
        <div
          class="mobile-drawer-bg"
          v-if="openDrawer"
          @click="toggleMobDrawer"
        ></div>
        <div class="mobile-drawer">
          <div class="mobile-drawer-rela">
            <a
              class="mobile-drawer-close"
              href="javascript:void(0)"
              @click="toggleMobDrawer"
            >
              <svg
                fill="currentColor"
                preserveAspectRatio="xMidYMid meet"
                height="14px"
                width="14px"
                viewBox="0 0 10 10"
                style="vertical-align: middle"
              >
                <title id="Close">Close</title>
                <g>
                  <path
                    d="M9.888641,1.2053571 C9.962881,1.2797623 10,1.3690471 10,1.4732143 C10,1.5773815 9.962881,1.6666663 9.888641,1.7410714 L6.904232,4.7321429 C6.829992,4.806548 6.792873,4.8958328 6.792873,5 C6.792873,5.1041672 6.829992,5.193452 6.904232,5.2678571 L9.86637,8.2589286 C9.955457,8.3333337 10,8.4226185 10,8.5267857 C10,8.6309529 9.955457,8.7202377 9.86637,8.7946429 L8.797327,9.8883929 C8.723088,9.962798 8.63029,10 8.518931,10 C8.407572,10 8.314774,9.962798 8.240535,9.8883929 L5.278396,6.8973214 C5.204157,6.8229163 5.111359,6.7857143 5,6.7857143 C4.888641,6.7857143 4.795843,6.8229163 4.721604,6.8973214 L1.737194,9.8883929 C1.662954,9.962798 1.573868,10 1.469933,10 C1.365998,10 1.276912,9.962798 1.202673,9.8883929 L0.111359,8.7946429 C0.037119,8.7202377 0,8.6309529 0,8.5267857 C0,8.4226185 0.037119,8.3333337 0.111359,8.2589286 L3.095768,5.2678571 C3.170008,5.193452 3.207127,5.1041672 3.207127,5 C3.207127,4.8958328 3.170008,4.806548 3.095768,4.7321429 L0.111359,1.7410714 C0.037119,1.6666663 0,1.5736613 0,1.4620536 C0,1.3504459 0.037119,1.2574408 0.111359,1.1830357 L1.202673,0.1116071 C1.276912,0.037202 1.36971,0 1.481069,0 C1.592428,0 1.685226,0.037202 1.759465,0.1116071 L4.721604,3.1026786 C4.795843,3.1770837 4.888641,3.2142857 5,3.2142857 C5.111359,3.2142857 5.204157,3.1770837 5.278396,3.1026786 L8.262806,0.1116071 C8.337046,0.037202 8.426132,0 8.530067,0 C8.634002,0 8.723088,0.037202 8.797327,0.1116071 L9.888641,1.2053571 Z"
                  />
                </g>
              </svg>
            </a>

            <div class="game-logo">
              <a href="javascript:void(0)">
                <div class="logo-cont"></div>
              </a>
              <a
                href="https://access.gaminglabs.com/Certificate/Index?i=354"
                target="_blank"
                class="logo-cert"
              ></a>
            </div>

            <!-- result button "@click="openWindow(gamehistoryUrl)"-->
            <a
              class="drawer-link"
              href="javascript:void(0)"
              @click="$root.openWindow(gamehistoryUrl)"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="14.004"
                  viewBox="0 0 16 14.004"
                >
                  <g transform="translate(-8578.002 -13913)">
                    <g>
                      <path
                        d="M7186.263,15366.8s-4.946-.008-8.421,0"
                        transform="translate(1406.739 -1452.799)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                      <path
                        d="M7179.844,15366.8s-1.174,0-2,0"
                        transform="translate(1401.158 -1452.798)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                    <g transform="translate(0 12)">
                      <path
                        d="M7186.263,15366.8s-4.946-.008-8.421,0"
                        transform="translate(1406.739 -1452.799)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                      <path
                        d="M7179.844,15366.8s-1.174,0-2,0"
                        transform="translate(1401.158 -1452.798)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                    <g transform="translate(8579.002 13920)">
                      <path
                        d="M7177.842,15366.8s4.946-.008,8.421,0"
                        transform="translate(-7177.842 -15366.799)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                      <path
                        d="M7177.844,15366.8s1.174,0,2,0"
                        transform="translate(-7165.844 -15366.798)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                </svg>
              </span>
              {{ $t("general.menuresult") }}
            </a>
            <!-- statement button "@click="openWindow(statementUrl)"-->
            <a
              class="drawer-link"
              href="javascript:void(0)"
              @click="$root.openWindow(statementUrl)"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="20"
                  viewBox="0 0 18 20"
                >
                  <g id="writing" transform="translate(-26.57)">
                    <g transform="translate(26.57)">
                      <g>
                        <path
                          d="M116.328,200.8a.8.8,0,0,0-.8-.8h-8.264a.8.8,0,1,0,0,1.6h8.264A.8.8,0,0,0,116.328,200.8Z"
                          transform="translate(-103.407 -192.205)"
                          fill="#fff"
                        />
                        <path
                          d="M107.261,280a.8.8,0,0,0,0,1.6h5.019a.8.8,0,0,0,0-1.6Z"
                          transform="translate(-103.365 -269.087)"
                          fill="#fff"
                        />
                        <path
                          d="M32.315,18.438H29.7a1.565,1.565,0,0,1-1.564-1.562V3.125A1.565,1.565,0,0,1,29.7,1.563h9.617A1.565,1.565,0,0,1,40.88,3.125v4.8a.782.782,0,0,0,1.564,0v-4.8A3.131,3.131,0,0,0,39.316,0H29.7A3.131,3.131,0,0,0,26.57,3.125v13.75A3.131,3.131,0,0,0,29.7,20h2.616a.781.781,0,1,0,0-1.562Z"
                          transform="translate(-26.57)"
                          fill="#fff"
                        />
                        <path
                          d="M252.46,272.728a2.41,2.41,0,0,0-3.4,0l-4.4,4.4a.8.8,0,0,0-.2.335l-.959,3.158a.8.8,0,0,0,.982,1.006l3.238-.9a.8.8,0,0,0,.353-.205l4.4-4.387A2.41,2.41,0,0,0,252.46,272.728Zm-5.38,6.507-1.629.451.477-1.57,2.972-2.966,1.135,1.135ZM251.326,275l-.155.155-1.135-1.135.155-.155A.8.8,0,0,1,251.326,275Z"
                          transform="translate(-235.164 -261.651)"
                          fill="#fff"
                        />
                        <path
                          d="M115.526,120h-8.264a.8.8,0,1,0,0,1.6h8.264a.8.8,0,0,0,0-1.6Z"
                          transform="translate(-103.407 -115.323)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              {{ $t("general.menustatement") }}
            </a>
            <!-- rules button "@click="openWindow(rulesUrl)"-->
            <a
              class="drawer-link"
              href="javascript:void(0)"
              @click="$root.openWindow(rulesUrl)"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g transform="translate(-1255 -25)">
                    <g id="question-mark" transform="translate(1256.447 30.71)">
                      <path
                        d="M8.323,0c1.632,0,3.238.751,3.238,2.549,0,1.658-1.9,2.295-2.307,2.894-.306.446-.2,1.072-1.045,1.072a.811.811,0,0,1-.816-.854c0-1.518,2.23-1.861,2.23-3.111,0-.688-.458-1.1-1.223-1.1-1.632,0-.995,1.682-2.23,1.682a.763.763,0,0,1-.829-.777C5.34,1.108,6.767,0,8.323,0ZM8.259,7.342A1.046,1.046,0,1,1,7.214,8.387,1.05,1.05,0,0,1,8.259,7.342Z"
                        transform="translate(0)"
                        fill="#fff"
                      />
                    </g>
                    <g
                      id="Ellipse_907"
                      data-name="Ellipse 907"
                      transform="translate(1255 25)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="1.5"
                    >
                      <circle cx="10" cy="10" r="10" stroke="none" />
                      <circle cx="10" cy="10" r="9.25" fill="none" />
                    </g>
                  </g>
                </svg>
              </span>
              {{ $t("general.menurules") }}
            </a>
            <!-- notification button "@click="openWindow(notificationUrl)"-->
            <a
              class="drawer-link"
              href="javascript:void(0)"
              @click="$root.openWindow(notificationUrl)"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                >
                  <path
                    id="Icon"
                    d="M1409,39a1,1,0,0,1-1-1V33a5.687,5.687,0,0,0-5-5.921V26a1,1,0,1,0-2,0v1.079A5.687,5.687,0,0,0,1396,33v5a1,1,0,0,1-1,1,1,1,0,0,0,0,2h4v1a3,3,0,1,0,6,0V41h4a1,1,0,0,0,0-2Zm-6,3a1,1,0,1,1-2,0V41h2Zm3-3h-8V33a3.843,3.843,0,0,1,4-4h0a3.843,3.843,0,0,1,4,4Z"
                    transform="translate(-1394 -25)"
                    fill="#fff"
                  />
                </svg>
              </span>
              {{ $t("general.menunotification") }}
            </a>
            <!-- <a class="drawer-link" href="javascript:void(0)" @click="favmodal = true">
              <span>
                <svg
                  fill="#fff"
                  height="21"
                  viewBox="0 0 16 16"
                  width="21"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m12.853 16.0905c-.0688477 0-.138184-.014183-.203125-.0430384l-4.61816-2.05606-4.61816 2.05606c-.170898.0758066-.370117.0493956-.515625-.0670033-.145996-.116888-.214355-.30567-.177734-.489072l1.01855-5.10249-3.56055-3.5668c-.130371-.130582-.178223-.322299-.125-.499343.0532227-.176555.199707-.309583.380371-.345774l5.10352-1.02265 2.0376-4.59239c.161133-.361913.75293-.361913.914063 0l2.0376 4.59239 5.10352 1.02265c.180664.0361915.327148.169219.380371.345774.0532227.177044.0053711.368761-.125.499343l-3.56055 3.5668 1.01855 5.10249c.0366211.183402-.0317383.372184-.177734.489072-.0903321.072383-.201172.110042-.3125.110042zm-4.82129-3.14816c.0693359 0 .138672.014183.203125.0430384l3.93848 1.75381-.881836-4.41681c-.0327148-.164328.0185547-.334036.136719-.452392l3.08936-3.09436-4.44092-.890111c-.15918-.0317899-.292969-.138897-.358887-.287575l-1.68604-3.7996-1.68604 3.7996c-.065918.148678-.199707.255785-.358887.287575l-4.44092.890111 3.08936 3.09436c.118164.118356.169434.288064.136719.452392l-.881836 4.41681 3.93848-1.75381c.064453-.0288553.133789-.0430384.203125-.0430384z"
                    transform="translate(-.032 -.09)"
                  />
                </svg>
              </span>
              {{ $t("general.menufavourite") }}
            </a>-->

            <div
              class="multiplechoices"
              v-on:click="toggleMobLanguage"
              v-bind:class="{ open: openLanguage }"
            >
              <div class="selected">{{ languages[lang_id].name }}</div>
              <div class="choices">
                <div
                  class="choice"
                  v-for="(lang, key) in languages"
                  :value="key"
                  @click="setLocale(key)"
                >
                  {{ lang.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div style="padding: 10px; width: 100%">
              <a
                :class="['drawer-toggle', goodroadOn ? 'roadon' : 'roadoff']"
                href="javascript:void(0)"
                @click="toggleGoodroad"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22.756"
                    height="22.756"
                    viewBox="0 0 22.756 27"
                  >
                    <g transform="translate(-1529.086 -78)">
                      <g
                        transform="translate(1530 78)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1537 78)"
                        fill="none"
                        stroke="#3e7ffd"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1530 85)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1544 78)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1544 85)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1537 85)"
                        fill="none"
                        stroke="#3e7ffd"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1544 92)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1537 92)"
                        fill="none"
                        stroke="#3e7ffd"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1544 99)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1537 99)"
                        fill="none"
                        stroke="#3e7ffd"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1530 99)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <g
                        transform="translate(1530 92)"
                        fill="none"
                        stroke="#fa594f"
                        stroke-width="1.5"
                      >
                        <circle cx="3" cy="3" r="3" stroke="none" />
                        <circle cx="3" cy="3" r="2.25" fill="none" />
                      </g>
                      <path
                        class="stroke"
                        d="M9297.84,13967l-6.228,6.228-1.11,1.11-2.057,2.058-10.533,10.532"
                        transform="translate(-7747.412 -13885.501)"
                        fill="none"
                        stroke="#ffbd54"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                </span>
                {{ $t("general.goodroad") }}
                {{ goodroadOn ? $t("general.menuon") : $t("general.menuoff") }}
              </a>
            </div>

            <div style="padding: 10px; width: 100%">
              <a
                :class="['drawer-toggle', soundOn ? 'soundon' : 'soundoff']"
                href="javascript:void(0)"
                @click="toggleSound"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21.928"
                    height="21.927"
                    viewBox="0 0 21.928 21.927"
                  >
                    <g transform="translate(-6534.5 -14643.5)">
                      <g id="speaker" transform="translate(6535 14641.989)">
                        <path
                          d="M11.352,3.172a1.21,1.21,0,0,0-1.235.018.371.371,0,0,0-.052.037L4.65,7.808H.4a.4.4,0,0,0-.4.4V15.8a.4.4,0,0,0,.4.4l4.241,0,5.413,4.972a.39.39,0,0,0,.064.048,1.211,1.211,0,0,0,1.235.018,1.248,1.248,0,0,0,.638-1.1V4.273A1.249,1.249,0,0,0,11.352,3.172Zm-.161,16.964a.459.459,0,0,1-.231.406.419.419,0,0,1-.4.01L5.2,15.624V13.8a.4.4,0,1,0-.8,0v1.6l-3.6,0V8.607H4.4v1.6a.4.4,0,0,0,.8,0V8.393l5.358-4.532a.418.418,0,0,1,.406.007.458.458,0,0,1,.231.405Z"
                          transform="translate(0 0)"
                          fill="#fff"
                          stroke="#fff"
                          stroke-width="0.8"
                        />
                        <path
                          d="M38,7.034a.4.4,0,0,0-.257.757,6.987,6.987,0,0,1,.009,13.232.4.4,0,0,0,.129.778.394.394,0,0,0,.129-.022A7.787,7.787,0,0,0,38,7.034Z"
                          transform="translate(-22.497 -2.403)"
                          fill="#fff"
                          stroke="#fff"
                          stroke-width="0.8"
                        />
                        <path
                          d="M34.948,15.989a3.627,3.627,0,0,0-2.607-3.467.267.267,0,1,0-.148.514,3.073,3.073,0,0,1,0,5.905.267.267,0,0,0,.074.524.272.272,0,0,0,.074-.01A3.626,3.626,0,0,0,34.948,15.989Z"
                          transform="translate(-18.21 -3.985)"
                          fill="#fff"
                          stroke="#fff"
                          stroke-width="0.8"
                        />
                      </g>
                      <path
                        class="stroke"
                        d="M9297.84,13967l-19.928,19.928"
                        transform="translate(-2742.412 677.499)"
                        fill="none"
                        stroke="#00fdf3"
                        stroke-linecap="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                </span>
                {{ $t("general.menusfx") }}:
                {{ soundOn ? $t("general.menuon") : $t("general.menuoff") }}
              </a>
            </div>

            <a :href="logoutURL" class="drawerlogout">
              {{ $t("general.menulogout") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenLite, TimelineLite } from "gsap";
import axios from "../../configs/axios";
import { uniqBy, head, first } from "lodash";
import {
  Row,
  Modal,
  Checkbox,
  CheckboxGroup,
  Icon,
  Button,
  Card,
  Divider,
} from "iview";
export default {
  props: [
    "user",
    "games",
    "formatPrice",
    "languages",
    "lang_id",
    "currentTime",
    "soundOn",
    "goodroadOn",
    "openDrawer",
    "openLanguage",
    "statementUrl",
    "betsUrl",
    "gamehistoryUrl",
    "rulesUrl",
    "notificationUrl",
  ],
  components: {
    Modal,
    Checkbox,
    CheckboxGroup,
    Icon,
    Button,
    Card,
    Divider,
  },
  computed: {
    logoutURL() {
      return window.logoutphp;
    },
  },
  watch: {
    favmodal() {
      if (this.favmodal === true) {
        this.temp_fav_array = [];
        this.temp_gIDArray = [];

        for (let index = 0; index < this.games.length; index++) {
          if (this.games[index].fav) {
            this.temp_fav_array.push(this.games[index]);

            this.temp_gIDArray.push(this.games[index].gID);
          }
        }
      }
    },
    games() {
      if (this.games.length > 0 && this.favInit === false) {
        this.fav_array = [];
        this.gIDArray = [];
        for (let index = 0; index < this.games.length; index++) {
          if (this.games[index].fav) {
            this.fav_array.push(this.games[index]);
            this.gIDArray.push(this.games[index].gID);
          }
        }

        this.favInit = true;
      }
    },
  },
  data() {
    return {
      gameList: [],
      favmodal: false,
      social: ["facebook", "github"],

      fav_array: [],
      tmp_array: [],
      temp_fav_array: [],
      temp_gIDArray: [],
      temp_games: [],
      complete_array: [],
      sortArray: [],
      gIDArray: [],
      favInit: false,
      isMarquee: false,
    };
  },
  mounted() {
    if (this.$refs["marquee"].scrollWidth > this.$refs["marquee"].clientWidth) {
      this.isMarquee = true;
    } else {
      this.isMarquee = false;
    }
  },
  methods: {
    async ok() {
      // try {
      //   this.sortArray = [];
      //   for (let l = 0; l < this.fav_array.length; l++) {
      //     this.sortArray.push(this.fav_array[l].gID);
      //   }
      //   let formData = new FormData();
      //   formData.append("gID", this.sortArray);
      //   let res = await axios.post(favGames, formData);
      //   let resData = res.data;
      //   if (resData.error) {
      //   } else {
      //     this.$root.checkUpdate();
      //   }
      // } catch (e) {}
    },
    cancel() {
      this.fav_array = [];
      this.gIDArray = [];
      this.gIDArray = this.temp_gIDArray;
      this.fav_array = this.temp_fav_array;
    },
    favUp(key) {
      let favIndex;
      let previousKey;
      for (let index = 0; index < this.fav_array.length; index++) {
        if (key === this.fav_array[index]) {
          favIndex = index;
          previousKey = this.fav_array[index - 1];
        }
      }
      this.fav_array.splice(favIndex - 1, 1, key);
      this.fav_array.splice(favIndex, 1, previousKey);
    },
    favDown(key) {
      let favIndex;
      let nextKey;
      for (let index = 0; index < this.fav_array.length; index++) {
        if (key === this.fav_array[index]) {
          favIndex = index;
          nextKey = this.fav_array[index + 1];
        }
      }
      this.fav_array.splice(favIndex, 1, nextKey);
      this.fav_array.splice(favIndex + 1, 1, key);
    },
    addToFav(key) {
      this.tmp_array = [...this.fav_array];
      this.fav_array = [key];
      this.gIDArray.push(key.gID);

      for (let index = 0; index < this.tmp_array.length; index++) {
        this.fav_array.push(this.tmp_array[index]);
      }
    },
    delFav(key) {
      this.tmp_array = [];
      this.gIDArray = [];

      for (let index = 0; index < this.fav_array.length; index++) {
        if (key != this.fav_array[index]) {
          this.gIDArray.push(this.fav_array[index].gID);
          this.tmp_array.push(this.fav_array[index]);
        }
      }
      this.fav_array = [...this.tmp_array];
    },
    toggleSound() {
      this.$emit("toggle-sound");
    },
    toggleGoodroad() {
      this.$emit("toggle-goodroad");
    },
    toggleMobDrawer() {
      this.$emit("toggle-mob-drawer");
    },
    checkBalance() {
      this.$emit("check-balance");
    },
    toggleMobLanguage() {
      this.$emit("toggle-mob-language");
    },
    setLocale(key) {
      this.$emit("set-Locale", key);
    },
  },
};
</script>

<style lang="scss" scoped>
.marquee.marquee-active {
  -webkit-transition: 0.5s ease-in;
  -moz-transition: 0.5s ease-in;
  -o-transition: 0.5s ease-in;
  transition: 0.5s ease-in;

  width: 300px;
  height: 100%;
}

.marquee.marquee-active:hover {
  -moz-animation: move 4s linear infinite;
  -webkit-animation: move 4s linear infinite;
  animation: move 4s linear infinite;

  text-overflow: unset !important;
}
@-moz-keyframes move {
  0% {
    text-indent: 0px;
  }
  100% {
    text-indent: -300px;
  }
}
@-webkit-keyframes move {
  0% {
    text-indent: 0px;
  }
  100% {
    text-indent: -300px;
  }
}
@keyframes move {
  0% {
    text-indent: 0px;
  }
  100% {
    text-indent: -300px;
  }
}

.logo-cont {
  background: transparent url(../../assets/images/common/toplogo.png) center
    no-repeat;
  background-size: contain;
  display: block;
  height: 50px;
  width: 120px;
}

.logo-cert {
  background: transparent url(../../assets/images/common/gli-certified.png)
    center no-repeat;
  background-size: contain;
  display: block;
  height: 50px;
  width: 55px;
}

.topnav-cont {
  width: 100%;
  height: 70px;
  line-height: 70px;
  background: #292a2e;
  position: relative;
  z-index: 10;
}

.topnav-cont .left-menu {
  float: left;
}

.topnav-cont .right-menu {
  float: right;
}

.topnav-cont .left-menu .menu-item {
  line-height: 50px;
  padding: 10px 0 10px 5px;
  float: left;
  color: #fff;
}

.topnav-cont .right-menu .menu-item {
  line-height: 50px;
  padding: 10px 5px 10px 0;
  float: right;
  color: #fff;
}
.menu-dropdown {
  background: #3c3d44;
  border-radius: 5px;
  color: #fff;
  padding: 0 28px 0 8px;
  font-weight: bold;
  position: relative;
}

.menu-dropdown:hover {
  background: #235ac2;
}

.menu-dropdown:hover > span {
  // background: #b0c4e8;
}

.menu-dropdown > span:after {
  content: "";
  border-top: 6px solid #ffffff;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  right: 10px;
  top: 27px;
}

.menu-dropdown > span:before {
  content: "";
  border-bottom: 6px solid #ffffff;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  right: 10px;
  top: 17px;
}
.menu-dropdown:hover .dropdown-list {
  display: block;
}
.dropdown-list {
  position: absolute;
  left: 0;
  top: 50px;
  width: 100%;
  background: #3c3d44;
  z-index: 999;
  border-radius: 5px;
  display: none;
}
.dropdown-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  line-height: 40px;
  // padding: 0 13px;
  color: #c7cad0;
  border-radius: 5px;
  cursor: pointer;
}

.dropdown-item:hover {
  background: #235ac2;
  color: #fff;
}
.toggle-tooltip {
  display: none;
  position: absolute;
  height: 35px;
  line-height: 35px;
  min-width: 100px;
  left: -25px;
  right: -25px;
  top: 55px;
  border-radius: 5px;
  background: #235ac2;
  color: #fff;
}

.toggle-tooltip:before {
  position: absolute;
  left: 45px;
  top: -5px;
  content: "";
  border-bottom: 6px solid #235ac2;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.menu-toggle-item {
  background: #45464e;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  line-height: 60px;
  width: 46px;
  height: 50px;
  position: relative;
  cursor: pointer;
}
.desktop-varcont {
  cursor: pointer;
  display: inline-block;
  color: #fff;
  line-height: 50px;
  height: 50px;
  background: #3c3d44;
  border-radius: 4px;
  padding: 0 6px;
}

.desktop-varcont > span {
  height: 50px;
  color: #fff;
  font-weight: bold;
  padding: 0 5px;
  border-radius: 4px;
}

.desktop-varcont .loading-icon {
  width: 12px;
  height: 12px;
}

.desktop-varcont .loading-icon:after {
  width: 10px;
  height: 10px;
  border: 5px solid #fff;
  border-color: #fff transparent #fff transparent;
  top: 2px;
  position: absolute;
}
.desktop-varcont.menu-toggle-item {
  width: auto;
}
.mobile-varcont {
  display: inline-block;
  color: #fff;
  line-height: 38px;
  height: 38px;
  margin: 5px 5px 0;
  background: #3c3d44;
  border-radius: 4px;
  padding: 0 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: auto;
  max-width: 140px;
}

.mobile-varcont.username {
  font-size: 10px;
}

.mobile-varcont .loading-icon {
  width: 12px;
  height: 12px;
}

.mobile-varcont .loading-icon:after {
  width: 10px;
  height: 10px;
  border: 5px solid #fff;
  border-color: #fff transparent #fff transparent;
  top: 2px;
  position: absolute;
}

.mobile-varcont > span {
  height: 26px;
  color: #fff;
  font-weight: bold;
  padding: 0 5px;
  border-radius: 4px;
}

.menu-toggle-item:hover .toggle-tooltip {
  display: block;
}

.header-mobile {
  display: none;
}
.mobile-left-drawer {
  width: 100%;
  height: 1px;
  position: fixed;
  top: -1px;
  bottom: 0;
  left: 0;
  background-color: rgba(51, 51, 51, 0);
  z-index: 100;
}

.mobile-left-drawer.open {
  min-height: 100%;
  height: 100%;
}
.mobile-drawer-bg {
  width: 0;
  height: 0;
  transition: 0.3s background-color;
  background-color: rgba(51, 51, 51, 0);
  z-index: 5;
}
.mobile-left-drawer.open .mobile-drawer-bg {
  display: block;
  width: 100%;
  min-height: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(51, 51, 51, 0.5);
}
.mobile-drawer {
  min-height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: #383535;
  overflow-y: scroll;
  width: 260px;
  left: -260px;
  transition: 0.3s all;
}

.open .mobile-drawer {
  left: 0;
  z-index: 10;
}

.mobile-drawer-rela {
  position: relative;
}

.mobile-drawer-close {
  position: absolute;
  top: 2px;
  right: 9px;
  color: hsl(0, 0%, 100%);
  padding: 10px;
  font-size: 15px;
}
.game-logo {
  height: 50px;
  width: 100%;
  padding-left: 15px;
  background: #2f2a2a;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.mobile-drawer .bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.mobile-drawer .bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.drawer-toggle {
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding: 0 25px;
  color: #fff;
  font-weight: bold;
  display: block;
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  background: #2f2a2a;
  border-radius: 5px;
}

.drawer-toggle > span {
  float: left;
  width: 20px;
  height: 45px;
  line-height: 60px;
  display: block;
  text-align: center;
  vertical-align: middle;
  margin-right: 18px;
}

.drawer-toggle:hover,
.drawer-toggle:active,
.drawer-toggle:focus {
  text-decoration: none;
  color: #fff;
  background: #464343;
}
.drawerlogout {
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding: 0 25px;
  color: #fff;
  font-weight: bold;
  display: block;
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  background: #2f2a2a;
  border-radius: 5px;
}
.soundon svg .stroke,
.roadon svg .stroke {
  stroke-width: 0;
}

.soundoff svg .stroke,
.roadoff svg .stroke {
  stroke-width: 2;
}

.drawer-link {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 25px;
  color: #fff;
  font-weight: bold;
  display: block;
  font-size: 13px;
  text-decoration: none;
  text-align: left;
}

.drawer-link:hover,
.drawer-link:active,
.drawer-link:focus {
  text-decoration: none;
  color: #fff;
  background: #464343;
}

.drawer-link > span {
  float: left;
  width: 20px;
  height: 40px;
  line-height: 40px;
  display: block;
  text-align: center;
  vertical-align: middle;
  margin-right: 18px;
}
.multiplechoices .selected {
  width: 100%;
  height: 40px;
  line-height: 40px;
  // padding: 0 25px;
  padding: 0 14px;
  color: #fff;
  font-weight: bold;
  display: block;
  font-size: 13px;
  text-decoration: none;
  position: relative;
  background: #2f2a2a;
  text-align: left;
}

.multiplechoices .selected:before {
  border-bottom: 4px solid #fff;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  content: "";
  position: absolute;
  right: 26px;
  top: 13px;
}

.multiplechoices .selected:after {
  border-top: 4px solid #fff;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  content: "";
  position: absolute;
  right: 26px;
  top: 21px;
}

.multiplechoices .choice {
  height: 40px;
  line-height: 40px;
  width: 50%;
  float: left;
  // padding: 0 0 0 20px;
  padding: 0 0 0 14px;
  display: none;
  background-size: #152240;
  color: #c0c9dd;
  text-align: left;
}

.multiplechoices.open .choice {
  display: block;
}

.multiplechoices .choices {
  position: absolute;
  left: -260px;
  transition: 0.3s left;
}

.multiplechoices.open .choices {
  left: 0;
}
.fav-title {
  color: white;
  font-size: 14px;
  font-weight: bold;
}

@media screen and (max-width: 1000px) {
  .topnav-cont {
    display: none;
  }

  .header-mobile {
    display: block;
    position: relative;
    height: 52px;
    width: 100%;
    background-color: #292a2e;
    text-align: center;
    -webkit-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.1);
  }

  .header-mobile .left-nav {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin: 0;
    padding: 5px 20px;
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    line-height: 1;
    padding: 12px;
    background-color: #3c3d44;
    position: absolute;
    top: 5px;
    left: 10px;
  }

  .header-mobile .right-nav {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin: 0;
    padding: 5px 20px;
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    line-height: 1;
    padding: 6px;
    background-color: #3c3d44;
    position: absolute;
    top: 5px;
    right: 10px;
  }

  .center-nav {
    text-align: right;
    margin-right: 5px;
  }

  .logo-cert {
    height: 30px;
    width: 60px;
  }
}

@media screen and (max-width: 1400px) {
  .topnav-cont .menu-item {
    padding: 10px 2px;
  }
  .currenttime {
    display: none;
  }

  .menu-dropdown,
  .topnav-cont .left-menu .menu-item {
    font-size: 10px;
  }
}
</style>
<style>
.game-fav-list.ivu-card {
  background: #342f2f;
  margin: 2px;
}
.game-fav-list .ivu-card-body {
  padding-left: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1px;
  padding-bottom: 1px;
  background: #342f2f;
  color: white;
}
.game-fav-list .ivu-btn {
  margin: 3px;
}
.game-list .ivu-card-body {
  padding-left: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1px;
  background: #342f2f;
  padding-bottom: 1px;
}
.game-list.ivu-card {
  background: #342f2f;
  color: white;
  margin: 2px;
}
.favmodal .ivu-modal-content {
  background: #3e3838 url(../../assets/images/common/popoverbg.png) top center;
}
.favmodal .ivu-card-bordered {
  border-color: #342f2f;
}
.favmodal .ivu-modal-header p,
.ivu-modal-header-inner {
  color: white;
}
.favmodal .ivu-btn > span {
  color: white;
}
.favmodal .ivu-btn-text:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
